import { Component, HostListener, OnInit, inject, ChangeDetectionStrategy, signal, input } from '@angular/core';
import {Subscription} from 'rxjs';
import {SortService} from '../services/sort-service';


@Component({
    selector: '[sortable-column]',
    templateUrl: './sortable-column.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: []
})
export class SortableColumnComponent implements OnInit {
  private readonly sortService = inject(SortService);


  readonly columnName = input.required<string>({ alias: 'sortable-column' });

  readonly sortDirection = signal<string>('');

  private columnSortedSubscription!: Subscription;

  @HostListener('click')
  sort() {
    this.sortDirection.set(this.sortDirection() === 'asc' ? 'desc' : 'asc');
    this.sortService.columnSorted({sortColumn: this.columnName(), sortDirection: this.sortDirection()});
  }

  ngOnInit() {
    this.columnSortedSubscription = this.sortService.columnSorted$.subscribe(event => {
      if (this.columnName() != event.sortColumn) {
        this.sortDirection.set('');
      }
    });
  }

  ngOnDestroy() {
    this.columnSortedSubscription.unsubscribe();
  }

}
